/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createModuleAction, createReducer } from 'redux-app/utils/reducer'

const createAction = createModuleAction('SUBSCRIPTIONS')

export const plans = createAction('PLANS')
export const setRenewalPlans = createAction('RENEWAL_PLANS')
export const selectPlan = createAction('SELECT_PLAN')

const ACTION_HANDLERS = {
  [plans.toString()]: (state, { payload }) => ({
    ...state,
    subscriptionPlans: payload,
  }),
  [setRenewalPlans.toString()]: (state, { payload }) => ({
    ...state,
    renewalPlans: payload,
  }),
  [selectPlan.toString()]: (state, { payload }) => ({
    ...state,
    selectedPlanId: payload,
  }),
}

const initialState = {
  subscriptionPlans: [],
  renewalPlans: [],
  selectedPlanId: null,
}

export default createReducer(initialState, ACTION_HANDLERS)
